import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import DataTable from "../../common/components/DataTable";
import FilterView from "../../common/components/FilterView";
import { IDataTableColumn } from "../../common/types/dataTable";
import { AppDispatch, RootState } from "../template/store";
import { useEffect, useRef, useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import queryString from "query-string";
import {
  Outlet,
  Link,
  matchPath,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import OblDetails from "../../common/components/OblDetails";
import { AESDecrypt, AESEncrypt } from "../../../encrypt-util";
import { IConfigsDefinition } from "../../utils/columnConfig";

import { getColumnViews } from "../../common/actions/dataTable";
import {
  updateDashbaordRefresh,
  updateParams,
  updateSortStateDataTable,
} from "../../common/components/DataTable/slices/DataTable";
import { getDashboardData } from "../dashboard/actions/dashboard";
import {
  clearMappingDashboard,
  updateCurrentPageMapping,
} from "../dashboard/slices/dashboardSlice";
import { updateDashbaordName } from "../../common/slices/navbarTop";

import moment from "moment";
import DashboardContainer from "../../../components/common/DashboardContainer";
import useDataCountry from "../../../hooks/useDataCountry";
import {
  setMappingTopSearchFilter,
  toggleColumnSettingsPayDash,
} from "./MappingSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUpload, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import CustomerDetailsSlider from "./MappingCustomerDetailsSlider";
import { useAmountFormatter } from "../../../hooks/useAmountFormatter";
import { useGenerateColumnConfig } from "../../../hooks/useGenerateColumnConfig";
import AddCustomerDetails from "./AddCustomerDetails";
import axiosInstance from "../../../axiosSetup";
import UploadIndicator from "../../../components/common/UploadIndicator";
import { preRegisterCustomersFromExcel } from "./MappingActions";

const gridName = "CUSTOMER_DASHBOARD";
const dashboardName = "CUSTOMER_DASHBOARD";
const filterKey = "mapingDashboard";

const MappingDashboard = () => {
  const { blNum } = useParams();
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';

  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const [columns, setColumns] = useState<IDataTableColumn[]>([]);
  const [configs, setConfigs] = useState<IConfigsDefinition>({
    columns: [],
    staticHiddenCols: [],
    defaultHiddenCols: [],
  });
  const refresh = useSelector(
    (state: RootState) => state.dataTable.refreshDashboard
  );
  const currentPage = useSelector(
    (state: RootState) => state.dashboard.currentPageMapping
  );

  const data = useSelector(
    (state: RootState) => state.dashboard.mappingDashboardList
  );

  const filterState = useSelector(
    (state: RootState) => state.dataTable.filterState
  );
  const grids = useSelector((state: RootState) => state.dataTable.mappingGrids);

  const [previousState, setPreviousState] = useState<{
    filterState: string | null;
    search: string | null;
    grids: any[] | null;
  }>({
    filterState: "{}",
    search: "",
    grids: grids?.[0]?.gridId,
  });
  const [currentState, setCurrentState] = useState<{
    filterState: string | null;
    search: string | null;
    grids: any[] | null;
  }>({
    filterState: "{}",
    search: "",
    grids: grids?.[0]?.gridId,
  });
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const sortState = useSelector(
    (state: RootState) => state.dataTable.sortState
  );
  const setCurrentPage = (page: number) => {
    dispatch(updateCurrentPageMapping(page));
  };

  const topSearchState = useSelector(
    (state: RootState) => state.navbarTop.mappingTopSearchState
  );
  const selectedConfigId = useSelector(
    (state: RootState) => state.dataTable.selectedConfigId
  );
  const selectedTopSearchFilter = useSelector(
    (state: RootState) => state.navbarTop.selectedTopSearchFilter
  );
  const searchInputValue = useSelector(
    (state: RootState) => state.mappingDashboard.mappingTopSearch
  );

  const rbac = useSelector((state: RootState) => state.userProfile);

  const dataCountry = useDataCountry();
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const language = useSelector((state: RootState) => state.navbarTop.language);
  const { t } = useTranslation();
  const [dropdownDownVisible, setdropdownDownVisible] = useState(false);
  const [fileName, setFileName] = useState("Upload File");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [serverFilePath, setServerFilePath] = useState<string | null>(null);
  const [loadingFileState, setLoadingFileState] = useState<number | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [isUnderlined, setIsUnderlined] = useState(false);

  const charLimit = (name: string, limit: number) =>
    name && name?.length >= limit ? name?.substring(0, limit) + "..." : name;

  const linkStyle = {
    cursor: "pointer",
    fontSize: "12px",
    fontStyle: "italic" as const,
    color: "#2c7be5",
    textDecoration: isUnderlined ? "underline" : "none",
  };

  const resetTemplateUpload = () => {
    setFileName("Upload File");
    setSelectedFile(null);
    setServerFilePath(null);
    setLoadingFileState(null);
    setSubmitting(false);
  };

  const handleFileChange = (event: any) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];

      if (!file.name.endsWith(".xlsx")) {
        toast.error("Please select a valid XLSX file.");
        event.target.value = null;
        return;
      }

  if (file.size > 10 * 1024 * 1024) {
  toast.error(String(t("resource_message:fileSizeExceeding10mb")));
  event.target.value = null;
  return;
}


      setFileName(file.name);
      setSelectedFile(file);
      setServerFilePath(null);

      const formData = new FormData();
      formData.append("file", file);

      try {
        setLoadingFileState(0);
        axiosInstance
          .post("/api/edo-rest-v1/v1/view/file", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress(progressEvent: any) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / (progressEvent.total ?? 1)
              );
              setLoadingFileState(percentCompleted);
            },
          })
          .then((response: any) => {
            setLoadingFileState(100);
            setServerFilePath(response?.data?.path ?? null);
          })
          .catch(() => {
            setLoadingFileState(-1);
            setServerFilePath(null);
            toast.error("File upload failed");
          });
        event.target.value = null;
      } catch (error) {
        console.error("File Upload Error: ", error);
        toast.error("File upload failed");
      }
    }
  };

  const handleUpload = async () => {
    if (!serverFilePath) {
      toast.error("Please upload a file before submitting");
      return;
    }

    setSubmitting(true);
    dispatch(preRegisterCustomersFromExcel({ filePath: serverFilePath }))
      .unwrap()
      .then((result: any) => {
        const downloadUrl = result?.downloadUrl;
        if (downloadUrl) {
          toast.info(
            <span
              role="button"
              tabIndex={0}
              className="text-primary text-decoration-underline"
              style={{ cursor: "pointer" }}
              onClick={() => window.open(downloadUrl, "_blank", "noopener,noreferrer")}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  window.open(downloadUrl, "_blank", "noopener,noreferrer");
                }
              }}
            >
              Click Here to download response file.
            </span>,
            { autoClose: false }
          );
        } else {
          toast.error("Response file is not available");
        }

        resetTemplateUpload();
        setdropdownDownVisible(false);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  function useDebouncedEffect(effect: any, deps: any, delay: any) {
    const callback = useRef<any>();

    useEffect(() => {
      callback.current = effect;
    }, [effect]);

    useEffect(() => {
      const handler = () => {
        if (callback.current) {
          callback.current();
        }
      };

      const timer = setTimeout(handler, delay);

      return () => clearTimeout(timer);
    }, [...deps, delay]);
  }
  const generateColumnConfig = useGenerateColumnConfig();

  useEffect(() => {
    const mappingDashboardDefinition = grids?.[0]?.columnConfigGrid || "";

    if (!mappingDashboardDefinition) return;

    try {
      const configs = generateColumnConfig(
        JSON.parse(JSON.parse(mappingDashboardDefinition)),
        getParams
      );

      const columns = configs?.columns?.map((c) => c);
      setConfigs(configs);
      setColumns(columns);
    } catch (e) {
      console.error("Column Error: ", e);
    }
  }, [grids, location]);

  useEffect(() => {
    dispatch(updateDashbaordName(gridName));
    dispatch(setMappingTopSearchFilter(""));
  }, []);

  const filterStateLocal = filterState?.[filterKey];
  const sort = (queryString.parse(location.search)?.sort as string)
    ?.split?.(",")
    ?.join?.(" ");

  useEffect(() => {
    if (location?.pathname && dataCountry && linerId) {
      dispatch(
        getColumnViews({
          gridName: dashboardName,
          country: dataCountry,
          linerId: linerId,
          language: language || localStorage.getItem('selectedLanguage') || 'EN',
        })
      );
    }
    dispatch(updateParams({}));
  }, [dataCountry, linerId, language]);

  useEffect(() => {
    loadmappingDashboard(false);
  }, [currentPage]);

  useEffect(() => {
    if (refresh) loadmappingDashboard(false);
    // server sometimes takes time to update the view so the delay
    setTimeout(() => dispatch(updateDashbaordRefresh(false)), 2000);
  }, [refresh]);

  useEffect(() => {
    if (matchPath(location.pathname.toLowerCase(), "/mappingdashboard"))
      loadmappingDashboard(false);
  }, [location.pathname]);

  useEffect(() => {
    const currentState = {
      filterState: JSON.stringify(filterStateLocal),
      search: location.search,
      grids: grids?.[0]?.gridId,
    };
    if (JSON.stringify(previousState) !== JSON.stringify(currentState)) {
      setCurrentState({
        filterState: JSON.stringify(filterStateLocal),
        search: location.search,
        grids: grids?.[0]?.gridId,
      });
    }
  }, [filterStateLocal, location.search, grids]);

  useDebouncedEffect(
    () => {
      if (JSON.stringify(previousState) !== JSON.stringify(currentState)) {
        loadmappingDashboard(true);
        setPreviousState(currentState);
      }
    },
    [currentState, linerId, language],
    700
  );

  useEffect(() => {
    loadmappingDashboard(true);
  }, [linerId, searchInputValue, language]);

  const loadmappingDashboard = (filterUpdated: boolean) => {
    if (filterUpdated) setCurrentPage(1);
    if (!searchInputValue || searchInputValue.trim() == "") {
      dispatch(clearMappingDashboard());
      return;
    }

    if (filterStateLocal) {
      if (Object.keys(filterStateLocal)?.length > 0) {
        const filterApiState: any = {};

        const filterKeys = Object.keys(filterStateLocal);

        for (let k of filterKeys) {
          if (filterStateLocal?.[k]?.from) {
            filterApiState[k] = [
              filterStateLocal?.[k]?.from || "",
              filterStateLocal?.[k]?.to || "",
            ].filter((i) => i);
          } else if (filterStateLocal?.[k]?.from !== undefined) {
            filterApiState[k] = undefined;
          } else {
            filterApiState[k] = filterStateLocal?.[k]
              ? typeof filterStateLocal?.[k] === "string"
                ? [filterStateLocal?.[k]]
                : filterStateLocal?.[k]
              : undefined || undefined;
          }
        }
        if (Object.keys(filterApiState)?.length > 0) {
          const finalFilterApiState: any = {};
          const currentDate = new Date();

          if (grids[0]) {
            let timeFlag = "";
            let timeDiff = 0;
            let dateRange: any = {};

            const newdata = grids[0].configGroup?.find(
              (c: any) => c.userGridId == selectedConfigId?.[filterKey]
            )?.columnConfigGrid;
            if (newdata) {
              timeFlag = JSON.parse(newdata).find(
                (item: any) => item.accessor == "invdt"
              )?.filterState;
              timeDiff = JSON.parse(newdata).find(
                (item: any) => item.accessor == "invdt"
              )?.timeDiff;
              dateRange = JSON.parse(newdata).find(
                (item: any) => item.accessor == "invdt"
              )?.dateRange;
            }
            if (filterApiState.invdt && timeFlag == "day" && dateRange) {
              filterApiState.invdt[1] = moment()
                .subtract(Math.abs(dateRange.to), "days")
                .endOf("day")
                .toISOString();
              filterApiState.invdt[0] = moment()
                .subtract(Math.abs(dateRange.from), "days")
                .startOf("day")
                .toISOString();
            }
          }
          for (let i of Object.keys(filterApiState)) {
            if (filterApiState[i]) {
              finalFilterApiState[i] = filterApiState[i];
            }
          }
          if (
            (profileDetails.partnerType === "customer" &&
              profileDetails.partnerId &&
              grids?.[0]?.whereClause) ||
            profileDetails.partnerType === "liner"
          ) {
            setTimeout(() => {
              dispatch(
                getDashboardData({
                  gridName: gridName,
                  payload: {
                    fields: /*  SelectedViewFields?.fields || */ [],
                    filters:
                      !selectedTopSearchFilter ||
                      selectedTopSearchFilter?.where == "" ||
                      searchInputValue.trim() === ""
                        ? finalFilterApiState
                        : {},

                    size: 20,
                    sorts:
                      sortState &&
                      sortState?.key != null &&
                      sortState?.value != null
                        ? [`${sortState?.key} ${sortState?.value}`]
                        : sort
                        ? [sort]
                        : ["id desc"],
                    page: filterUpdated ? 1 : currentPage,
                  },
                  dataCountry: dataCountry,
                  partnerId:
                    profileDetails.partnerType === "customer"
                      ? profileDetails.partnerId
                      : null,
                  where: grids?.[0]?.whereClause
                    ? AESEncrypt(grids?.[0]?.whereClause)
                    : null,
                  parameter:
                    selectedTopSearchFilter?.where !== "" &&
                    searchInputValue.trim() !== ""
                      ? {
                          searchParameter: searchInputValue,
                          searchWhere: selectedTopSearchFilter?.where,
                        }
                      : {},
                })
              );
            }, 250);
          }
        }
      } else {
        if (
          (profileDetails.partnerType === "customer" &&
            profileDetails.partnerId &&
            grids?.[0]?.whereClause) ||
          profileDetails?.partnerType === "liner"
        ) {
          setTimeout(() => {
            dispatch(
              getDashboardData({
                gridName: gridName,
                payload: {
                  fields: /* SelectedViewFields?.fields || */ [],
                  filters:
                    selectedTopSearchFilter?.where === "" ? topSearchState : {},
                  size: 20,
                  sorts:
                    sortState &&
                    sortState?.key != null &&
                    sortState?.value != null
                      ? [`${sortState?.key} ${sortState?.value}`]
                      : sort
                      ? [sort]
                      : ["id desc"],
                  page: filterUpdated ? 1 : currentPage,
                },
                dataCountry: dataCountry,
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
                where: grids?.[0]?.whereClause
                  ? AESEncrypt(grids?.[0]?.whereClause)
                  : null,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                        searchParameter: searchInputValue,
                        searchWhere: selectedTopSearchFilter?.where,
                      }
                    : {},
              })
            );
          }, 250);
        }
      }
    } else {
      if (
        location.pathname.toLowerCase().includes("/mappingdashboard") &&
        location?.state?.from == undefined
      ) {
        if (
          (profileDetails.partnerType === "customer" &&
            profileDetails.partnerId &&
            grids?.[0]?.whereClause) ||
          profileDetails.partnerType === "liner"
        ) {
          setTimeout(() => {
            dispatch(
              getDashboardData({
                gridName: gridName,
                payload: {
                  fields: /* SelectedViewFields?.fields || */ [],
                  filters:
                    selectedTopSearchFilter?.where == ""
                      ? { [selectedTopSearchFilter.id]: [searchInputValue] }
                      : {},
                  size: 20,
                  sorts:
                    sortState &&
                    sortState?.key != null &&
                    sortState?.value != null
                      ? [`${sortState?.key} ${sortState?.value}`]
                      : sort
                      ? [sort]
                      : ["id desc"],
                  page: filterUpdated ? 1 : currentPage,
                },
                dataCountry: dataCountry,
                partnerId:
                  profileDetails.partnerType === "customer"
                    ? profileDetails.partnerId
                    : null,
                where: grids?.[0]?.whereClause
                  ? AESEncrypt(grids?.[0]?.whereClause)
                  : null,
                parameter:
                  selectedTopSearchFilter?.where !== ""
                    ? {
                        searchParameter: searchInputValue,
                        searchWhere: selectedTopSearchFilter?.where,
                      }
                    : {},
              })
            );
          }, 250);
        }
      }
    }
  };

  const showColumnSettings = useSelector(
    (state: RootState) => state.mappingDashboard.showColumnSettings
  );

  const getParams = () => {
    return {
      blid: blNum ? AESDecrypt(blNum) : "",
      pmtmode: blNum ? AESDecrypt(blNum) : "",
    };
  };

  useEffect(() => {
    dispatch(updateParams({}));
    dispatch(
      updateSortStateDataTable({
        key: null,
      })
    );
  }, [dataCountry]);

  const sideWidth =
    Object.entries({
      [`/mappingdashboard`]: 0,
      [`/mappingdashboard/addcustomerdetails`]: 10,
      [`/mappingdashboard/customerdetails/:custId`]: 10,
      [`/mappingdashboard/customerdetails/:custId/addcode`]: 10,
      [`/mappingdashboard/customerdetails/:custId/edituser`]: 8,
      [`/mappingdashboard/customerdetails/:custId/edituser/:userId`]: 8,
    }).find(([path, _]) =>
      matchPath(path, location.pathname.toLowerCase())
    )?.[1] ?? 0;

  const inner = ["edituser", "addcode"].some((i) =>
    location.pathname.includes(i)
  );

  const FilterViewChild = (() => {

    return (
      <>
        {  (
          <Dropdown
            navbar={true}
            className="position-relative flex-shrink-0"
            onClick={() => setdropdownDownVisible(true)}
          >
            <Dropdown.Toggle
              bsPrefix="toggle"
              as={Link}
              to=""
              className="nav-link p-0"
            >
              <Button
                variant="falcon-primary"
                size="sm"
                className="d-flex align-items-center"
                style={{ width: "max-content" }}
                title="Template"
                onClick={() => {
                  resetTemplateUpload();
                }}
              >
                <FontAwesomeIcon
                  icon={faPlus}
                  style={{
                    fontSize: "14px",
                    color: "#f5822a",
                    marginRight: "0.5rem",
                  }}
                  title="Template"
                />
                <span>Template</span>
              </Button>
            </Dropdown.Toggle>

            {dropdownDownVisible && (
              <Dropdown.Menu
                className="dropdown-caret dropdown-menu-card dropdown-menu-end"
                style={{ minHeight: "90px" }}
              >
                <div>
                  <div className="row g-2 align-items-sm-center">
                    <div className="col">
                      <div className="row align-items-center">
                        <div className="col">
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            className="fs-0 text-primary"
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <label
                                className="btn btn-sm btn-falcon-primary"
                                style={{
                                  marginBottom: "0rem",
                                  margin: "0.5rem",
                                }}
                                htmlFor="mappingExcelFileInput"
                              >
                                <FontAwesomeIcon
                                  icon={faUpload}
                                  className="me-2"
                                  style={{
                                    fontSize: "16px",
                                    color: "#f5822a",
                                    marginLeft: "0.5rem",
                                    cursor: "pointer",
                                  }}
                                  title="Upload"
                                />
                              </label>
                              <input
                                type="file"
                                id="mappingExcelFileInput"
                                accept=".xlsx"
                                onClick={(event: any) => {
                                  event.target.value = "";
                                  setFileName(t("resource_2:uploadFile"));
                                  setSelectedFile(null);
                                  setServerFilePath(null);
                                  setLoadingFileState(null);
                                }}
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                              />
                              <span
                                style={{
                                  fontSize: "14px",
                                  color: "#2c7be5",
                                  fontWeight: "600",
                                }}
                              >
                                {charLimit(fileName, 15)}
                              </span>
                              {loadingFileState != null && (
                                <UploadIndicator
                                  style={{ marginLeft: "10px" }}
                                  progress={loadingFileState}
                                  fail={loadingFileState === -1}
                                />
                              )}
                            </div>

                            {loadingFileState === 100 && serverFilePath && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Button
                                  onClick={handleUpload}
                                  className="me-2"
                                  variant="falcon-primary"
                                  size="sm"
                                  style={{ margin: "0.5rem" }}
                                  type="submit"
                                  disabled={submitting}
                                >
                                  {submitting ? "Submitting…" : t("resource_1:submit")}
                                </Button>
                              </div>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Dropdown.Divider />
                  <div
                    style={{ width: "23rem" }}
                    className="row g-2 align-items-sm-center"
                  >
                    <div
                      className="col"
                      style={{
                        marginTop: "0.5rem",
                        marginLeft: "2rem",
                      }}
                    >
                      <span
                        onClick={() => {
                          window.open("/xlsx/Customer_Registration_Template.xlsx");
                        }}
                        onMouseEnter={() => setIsUnderlined(true)}
                        onMouseLeave={() => setIsUnderlined(false)}
                        className="text-primary"
                        style={{ ...linkStyle, marginTop: "5px", color: "#2c7be5" }}
                      >
                        {t("resource_message:downloadSampleExcel")}
                      </span>
                    </div>
                  </div>
                </div>
              </Dropdown.Menu>
            )}
          </Dropdown>
        )}

        {rbac.rbacDetails.showAddCustomerDetails === "Y" && (

          <>

            {!(
            location.pathname.toLowerCase().includes('/customerdetails') ||
            location.pathname.toLowerCase().includes('/addcustomerdetails')
            )  &&
            <>
              <Button
                variant="falcon-primary"
                className="d-flex align-items-center text-nowrap"
                size="sm"
                data-placement="left"
                data-toggle="tooltip"
                onClick={() => {
                  navigate(`${APP_PATH_PREFIX}/mappingdashboard/addcustomerdetails`)
                }}
              // style={{ marginRight: '0.5rem', position: 'relative' }}
              >
                <FontAwesomeIcon icon={faPlus} className='mx-1 me-2 mt-1 text-warning' />
                <span>Customer Details</span>
              </Button>
            </>}
          </>

        )} 

      </>

    );
  })();

  return (
    <DashboardContainer
      sideWidth={sideWidth}
      inner={inner}
      innerOffset={58}
      middleChildren={location.pathname.includes('/mappingdashboard/addcustomerdetails')  ? (<AddCustomerDetails/>): (<CustomerDetailsSlider disable={inner} />)}
    >
      <FilterView
        loadList={loadmappingDashboard}
        showUploadButton
        showColumnSettings={
          !!searchInputValue && searchInputValue.trim() !== ""
        }
        dataLoading={false}
        toggleColumnSettings={toggleColumnSettingsPayDash}
        columnSettingsPersistKey="@odex/paydash/v1"
        uniqueFilterKey="filterKey"
        configViews={
          grids?.find?.((g) => g?.gridName === dashboardName)?.configGroup || []
        }
        showRightDiv={
          !!matchPath(location.pathname.toLowerCase(), "/mappingdashboard")
        }
        dashboardName={dashboardName}
        data={data}
        gridDef={grids}
        child={<div className="d-flex align-items-center flex-wrap gap-2">{FilterViewChild}</div>}
      />
      {(searchInputValue ?? "").trim() == "" &&
        matchPath(location.pathname.toLowerCase(), "/mappingdashboard") && (
          <div className="flex-1 d-flex h-100 align-items-center justify-content-center">
            <span
              className="f-1"
              style={{
                userSelect: "none",
              }}
            >
              <FontAwesomeIcon icon={faXmarkCircle} /> Add Search Parameter In
              Top Filter
              <br />
              <br />
              <br />
              <br />
            </span>
          </div>
        )}
      {searchInputValue && searchInputValue.trim() !== "" && (
        <DataTable
          data={data?.result || null}
          columns={columns}
          dataCountry={dataCountry || ""}
          sortable
          searchable={false}
          showColumnFilter
          selection={false}
          perPage={20}
          pagination
          numberPagination
          maxPage={parseInt(data?.maxPage || "100")}
          hasNext={data?.hasNext}
          currentPage={currentPage}
          gridId={grids?.[0]?.gridId || 0}
          onChangePageNumber={(pageNumber) => setCurrentPage(pageNumber)}
          showExport={false}
          showColumnSettings={showColumnSettings}
          onHide={() => {
            dispatch(toggleColumnSettingsPayDash(false));
          }}
          columnSettingsPersistKey="@odex/mapDash/v1"
          customSort={false}
          uniqueFilterKey="filterKey"
          staticHiddenCols={configs?.staticHiddenCols || []}
          defaultHiddenCols={[]}
          tableMinHeight={400}
          gridName={dashboardName}
          dataLoading={false}
          configGroup={grids?.[0]?.configGroup || []}
        />
      )}
    </DashboardContainer>
  );
};

export default MappingDashboard;
